import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations';

const TermsOfService = () => {
  const { language } = useLanguage();
  const t = translations[language];
  const items = Array.isArray(t.termsOfService.userObligations.items)
    ? t.termsOfService.userObligations.items
    : [t.termsOfService.userObligations.items];

  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-8">{t.termsOfService.title}</h1>
      
      <div className="space-y-6">
        <section>
          <h2 className="text-2xl font-semibold mb-4">{t.termsOfService.acceptance.title}</h2>
          <p className="text-gray-700">{t.termsOfService.acceptance.content}</p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-4">{t.termsOfService.services.title}</h2>
          <p className="text-gray-700">{t.termsOfService.services.content}</p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-4">{t.termsOfService.userObligations.title}</h2>
          <ul className="list-disc pl-6 space-y-2 text-gray-700">
            {items.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-4">{t.termsOfService.privacy.title}</h2>
          <p className="text-gray-700">{t.termsOfService.privacy.content}</p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-4">{t.termsOfService.liability.title}</h2>
          <p className="text-gray-700">{t.termsOfService.liability.content}</p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-4">{t.termsOfService.termination.title}</h2>
          <p className="text-gray-700">{t.termsOfService.termination.content}</p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-4">{t.termsOfService.changes.title}</h2>
          <p className="text-gray-700">{t.termsOfService.changes.content}</p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-4">{t.termsOfService.contact.title}</h2>
          <p className="text-gray-700">{t.termsOfService.contact.content}</p>
        </section>
      </div>
    </div>
  );
};

export default TermsOfService; 